import React, { useState, useEffect, useCallback } from 'react'
import MiniCartProductCell from './MiniCartProductCell';
import { actionTypes, useStateValue } from "./../../store";
const MiniCartSidebar = () => {

    const [minicartItem, setMinicartItem] = useState(JSON.parse(localStorage.getItem("h_ct")) || []);
    const [{cartitemcount, token, huid }, dispatch] = useStateValue();
    
    useEffect(() => {
        dispatch({ type: actionTypes.SET_MINICARTITEM, value: minicartItem.length });
    }, [minicartItem]);


    const callback = useCallback((value) => {
         var removeProductItem = JSON.parse(localStorage.getItem('h_ct'));
         removeProductItem.splice(value, 1);
         localStorage.setItem('h_ct', JSON.stringify(removeProductItem));
         setMinicartItem(JSON.parse(localStorage.getItem('h_ct')));
    }, []);

    const rememberBasket = () => {
        localStorage.setItem('h_ct', JSON.stringify(minicartItem));
        setMinicartItem(JSON.parse(localStorage.getItem('h_ct')));
    }

    const callbackmin = useCallback((value, qty) => {
        var entry = minicartItem.find(function(e) { return e.id == value; });
        if (entry) {
            entry.qty -= 1; // Or just `= qty` to replace rather than adding
        } else {
            minicartItem.push({
                id: value,
                qty: qty
            });
        }
        rememberBasket();
    }, [minicartItem]);

    const callbackadd = useCallback((value, qty) => {
        var entry = minicartItem.find(function(e) { return e.id == value; });
        if (entry) {
            entry.qty += 1; // Or just `= qty` to replace rather than adding
        } else {
            minicartItem.push({
                id: value,
                qty: qty
            });
        }
        rememberBasket();
    },[minicartItem]);

   
    return (
        <>
            {minicartItem && minicartItem?.map((data, i) => (
                <MiniCartProductCell key={i} itemno={i} itemin={data} removeitem={callback} minusQty={callbackmin} addQty={callbackadd}  />
            ))}
        </>
    )
}

export default MiniCartSidebar